export default "__VITE_ASSET__H5Rc51qu__"